(function(){
var SHORT={'extra small':'XS','small':'S','medium':'M','large':'L','extra large':'XL'};
function label(v){if(v==='Default Title')return '+';return SHORT[v.toLowerCase()]||v;}
function money(c){if(window.Shopify&&Shopify.formatMoney){try{return Shopify.formatMoney(c,window.Shopify.money_format||'${{amount}}');}catch(e){}}return '$'+(c/100).toFixed(2);}
function addToCart(id,btn,done){
  btn.classList.add('is-loading');
  var cart=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
  var fd=new FormData();fd.append('id',id);fd.append('quantity','1');
  if(cart){try{fd.append('sections',cart.getSectionsToRender().map(function(s){return s.id;}).join(','));}catch(e){}fd.append('sections_url',window.location.pathname);if(cart.setActiveElement)cart.setActiveElement(document.activeElement);}
  var cfg;
  if(typeof fetchConfig==='function'){cfg=fetchConfig('javascript');}
  else{cfg={method:'POST',headers:{'Accept':'application/json'}};}
  cfg.headers['X-Requested-With']='XMLHttpRequest';delete cfg.headers['Content-Type'];cfg.body=fd;
  var url=(typeof routes!=='undefined'&&routes.cart_add_url)?routes.cart_add_url:'/cart/add.js';
  fetch(url,cfg).then(function(r){return r.json();}).then(function(resp){
    btn.classList.remove('is-loading');
    if(resp.status){btn.textContent='sold out';btn.disabled=true;return;}
    if(done)done();
    if(cart&&cart.renderContents){if(cart.classList.contains('is-empty'))cart.classList.remove('is-empty');cart.renderContents(resp);}
    else{window.location='/cart';}
  }).catch(function(){btn.classList.remove('is-loading');});
}
/* ---------- mobile quick-view panel ---------- */
var panel=null,backdrop=null,pTitle,pPrice,pGallery,pOpts,pAdd,pView,selectedId=null;
function ensurePanel(){
  if(panel)return;
  backdrop=document.createElement('div');backdrop.className='moss-qap-backdrop';
  panel=document.createElement('div');panel.className='moss-qap';panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');
  var head=document.createElement('div');head.className='moss-qap__head';
  var ht=document.createElement('div');
  pTitle=document.createElement('div');pTitle.className='moss-qap__title';
  pPrice=document.createElement('div');pPrice.className='moss-qap__price';
  ht.appendChild(pTitle);ht.appendChild(pPrice);head.appendChild(ht);
  var x=document.createElement('button');x.type='button';x.className='moss-qap__x';x.setAttribute('aria-label','Close');x.textContent='×';
  x.addEventListener('click',closePanel);head.appendChild(x);
  pGallery=document.createElement('div');pGallery.className='moss-qap__gallery';
  pOpts=document.createElement('div');pOpts.className='moss-qap__opts';
  pAdd=document.createElement('button');pAdd.type='button';pAdd.className='moss-qap__add';
  pAdd.addEventListener('click',function(){if(selectedId)addToCart(selectedId,pAdd,function(){closePanel();});});
  pView=document.createElement('a');pView.className='moss-qap__view';
  panel.appendChild(head);panel.appendChild(pGallery);panel.appendChild(pOpts);panel.appendChild(pAdd);panel.appendChild(pView);
  backdrop.addEventListener('click',closePanel);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&panel.classList.contains('is-open'))closePanel();});
  document.body.appendChild(backdrop);document.body.appendChild(panel);
}
function openPanel(p,handle){
  ensurePanel();selectedId=null;
  pTitle.textContent=p.title;pPrice.textContent=money(p.price);
  function renderGallery(lead){
    pGallery.innerHTML='';
    var imgs=(p.images||[]).slice();
    if(lead){
      var key=lead.split('?')[0];
      imgs=imgs.filter(function(s){return s.split('?')[0]!==key;});
      imgs.unshift(lead);
    }
    imgs.forEach(function(src){
      var img=document.createElement('img');img.loading='lazy';img.alt='';
      img.src=src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/,'_800x$1$2');
      pGallery.appendChild(img);
    });
    pGallery.style.display=imgs.length?'flex':'none';
    pGallery.scrollLeft=0;
  }
  renderGallery(null);
  pOpts.innerHTML='';
  if(p.options.length===2){
    pOpts.classList.add('moss-qap__opts--grouped');
    var sel=[null,null];
    var groups=[];
    function findVar(a,b){for(var i=0;i<p.variants.length;i++){var v=p.variants[i];if(v.options[0]===a&&v.options[1]===b)return v;}return null;}
    function anyAvail(idx,val,other){for(var i=0;i<p.variants.length;i++){var v=p.variants[i];if(!v.available)continue;if(v.options[idx]!==val)continue;if(other!==null&&v.options[1-idx]!==other)continue;return true;}return false;}
    function refresh(){
      groups.forEach(function(g,gi){
        g.btns.forEach(function(rec){
          var ok=anyAvail(gi,rec.val,sel[1-gi]);
          rec.b.disabled=!ok;rec.b.classList.toggle('is-soldout',!ok);
          rec.b.classList.toggle('is-selected',sel[gi]===rec.val);
        });
      });
      selectedId=null;
      if(sel[0]!==null&&sel[1]!==null){
        var v=findVar(sel[0],sel[1]);
        if(v&&v.available){selectedId=v.id;if(v.featured_image&&v.featured_image.src)renderGallery(v.featured_image.src);}
      }
      pAdd.disabled=!selectedId;
    }
    p.options.forEach(function(opt,gi){
      var gwrap=document.createElement('div');gwrap.className='moss-qap__group';
      var gl=document.createElement('div');gl.className='moss-qap__grouplabel';gl.textContent=opt.name.replace(/\s*\(size\)\s*/i,'');
      var grow=document.createElement('div');grow.className='moss-qap__grow';
      var recs=[];
      (opt.values||[]).forEach(function(val){
        var b=document.createElement('button');b.type='button';b.className='moss-qap__opt';b.textContent=val;
        b.addEventListener('click',function(){sel[gi]=(sel[gi]===val)?null:val;refresh();});
        grow.appendChild(b);recs.push({val:val,b:b});
      });
      gwrap.appendChild(gl);gwrap.appendChild(grow);pOpts.appendChild(gwrap);
      groups.push({btns:recs});
    });
    refresh();
  }else{
    pOpts.classList.remove('moss-qap__opts--grouped');
    var seen={},vals=[];
    p.variants.forEach(function(v){var val=v.options[0];if(!seen[val]){seen[val]=1;vals.push({val:val,id:v.id,avail:v.available,img:(v.featured_image&&v.featured_image.src)?v.featured_image.src:null});}});
    vals.forEach(function(x){
      var b=document.createElement('button');b.type='button';b.className='moss-qap__opt';b.textContent=x.val;
      if(!x.avail){b.disabled=true;b.classList.add('is-soldout');}
      b.addEventListener('click',function(){
        pOpts.querySelectorAll('.moss-qap__opt').forEach(function(o){o.classList.remove('is-selected');});
        b.classList.add('is-selected');selectedId=x.id;pAdd.disabled=false;
        if(x.img)renderGallery(x.img);
      });
      pOpts.appendChild(b);
    });
    if(vals.length===1&&vals[0].avail){selectedId=vals[0].id;pOpts.firstChild.classList.add('is-selected');if(vals[0].img)renderGallery(vals[0].img);}
  }
  pAdd.disabled=!selectedId;
  pAdd.textContent=(window.MOSS_QA_ADD||'Add to cart');
  pView.textContent=(window.MOSS_QA_VIEW||'view details');
  pView.setAttribute('href','/products/'+handle);
  backdrop.classList.add('is-open');panel.classList.add('is-open');
  document.documentElement.style.overflow='hidden';
}
function closePanel(){
  if(!panel)return;
  backdrop.classList.remove('is-open');panel.classList.remove('is-open');
  document.documentElement.style.overflow='';
}
/* ---------- card wiring ---------- */
function build(card){
  if(card.dataset.mossQa)return;card.dataset.mossQa='1';
  var link=card.querySelector('a[href*="/products/"]');if(!link)return;
  var m=(link.getAttribute('href')||'').match(/\/products\/([^/?#]+)/);if(!m)return;
  var handle=m[1];
  var inner=card.querySelector('.card__inner')||card;
  fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
    if(!p||!p.options||(p.options.length!==1&&p.options.length!==2)||!p.variants||!p.variants.length)return;
    var ov=document.createElement('div');ov.className='moss-qa';
    var lab=document.createElement('span');lab.className='moss-qa__label';lab.textContent=(window.MOSS_QA_LABEL||'quick add');ov.appendChild(lab);
    var row=document.createElement('div');row.className='moss-qa__row';
    if(p.options.length===2){
      var qb=document.createElement('button');qb.type='button';qb.className='moss-qa__btn';qb.textContent=(window.MOSS_QA_LABEL||'quick add');
      qb.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openPanel(p,handle);});
      row.appendChild(qb);
    }else{
      var seen={},vals=[];
      p.variants.forEach(function(v){var val=v.options[0];if(!seen[val]){seen[val]=1;vals.push({val:val,id:v.id,avail:v.available});}});
      if(!vals.length)return;
      vals.forEach(function(x){
        var b=document.createElement('button');b.type='button';b.className='moss-qa__btn';b.textContent=label(x.val);
        if(!x.avail){b.disabled=true;b.classList.add('is-soldout');}
        b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();addToCart(x.id,b);});
        row.appendChild(b);
      });
    }
    ov.appendChild(row);inner.appendChild(ov);
    var plus=document.createElement('button');plus.type='button';plus.className='moss-qa-plus';plus.setAttribute('aria-label',(window.MOSS_QA_LABEL||'quick add'));plus.textContent='+';
    plus.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();openPanel(p,handle);});
    inner.appendChild(plus);
  }).catch(function(){});
}
var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){build(en.target);io.unobserve(en.target);}});},{rootMargin:'250px'}):null;
function observe(){document.querySelectorAll('.card-wrapper:not([data-moss-qa])').forEach(function(c){if(io)io.observe(c);else build(c);});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',observe);}else{observe();}
new MutationObserver(function(){observe();}).observe(document.body,{childList:true,subtree:true});
})();
